const routerExpress = [
  {
    path: "/express/ajustes",
    name: "SettingsOrderExpress",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "SettingsOrderExpress" */ "@/views/Express/Settings.vue"
      ),
  },
  {
    path: "/express/ajustes/novo",
    name: "SettingsOrderFormExpress",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "SettingsOrderFormExpress" */ "@/views/Express/SettingsForm.vue"
      ),
  },
  {
    path: "/express/ajustes/:id",
    name: "SettingsOrderEditExpress",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "SettingsOrderFormExpress" */ "@/views/Express/SettingsForm.vue"
      ),
  },
  {
    path: "/express/grade-padrao",
    name: "StandardGridExpress",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "StandardGridExpress" */ "@/views/Express/StandardGrid.vue"
      ),
  },
  {
    path: "/express/manutencao-preco",
    name: "PriceMaintenanceExpress",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "PriceMaintenanceExpress" */ "@/views/Express/PriceMaintenance.vue"
      ),
  },
  {
    path: "/express/lancamento-estoque",
    name: "AdjustStock",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "AdjustStock" */ "@/views/Express/AdjustStock.vue"
      ),
  },
  {
    path: "/express/lancamento-estoque/:id",
    name: "AdjustStockEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "AdjustStock" */ "@/views/Express/AdjustStock.vue"
      ),
  },
  {
    path: "/express/aprovar-lancamento",
    name: "StockPending",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "StockPending" */ "@/views/Express/StockPending.vue"
      ),
  },
  {
    path: "/express/pedido",
    name: "OrderExpress",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "OrderExpress" */ "@/views/Express/OrderExpress.vue"
      ),
  },
  {
    path: "/express/banner",
    name: "BannerExpressList",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "BannerExpressList" */ "@/views/Express/BannerExpress/List.vue"
      ),
  },
  {
    path: "/express/banner/novo",
    name: "BannerExpressForm",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "BannerExpressForm" */ "@/views/Express/BannerExpress/Form.vue"
      ),
  },
  {
    path: "/express/banner/:id",
    name: "BannerExpressEdit",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "BannerExpressForm" */ "@/views/Express/BannerExpress/Form.vue"
      ),
  },
];

export default routerExpress;
